import { get, noop } from 'lodash';
export const timeoutPromise = (promise, ms, errMsg, abortSignal = {}) => {
    const abort = get(promise, 'abort', noop);
    const resolvedPromise = get(promise, 'ready', promise);
    const onAbort = () => abort();
    if (abortSignal.aborted) {
        abort();
    }
    else if (abortSignal.addEventListener) {
        abortSignal.addEventListener('abort', onAbort);
    }
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            abort();
            const error = new Error(errMsg);
            error.name = 'TimeoutError';
            reject(error);
        }, ms);
        const cleanup = () => {
            clearTimeout(timeoutId);
            if (abortSignal.removeEventListener) {
                abortSignal.removeEventListener('abort', onAbort);
            }
        };
        resolvedPromise.then((value) => {
            cleanup();
            resolve(value);
        }, (error) => {
            cleanup();
            reject(error);
        });
    });
};
//# sourceMappingURL=timeout-promise.js.map